import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from 'src/commons/services/toast.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private toast: ToastService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse && (err.status === 408 || err.status === 504)) {
          this.toast.add({
            severity: 'error',
            summary: 'Tiempo de espera agotado',
            detail: 'La petición ha tardado demasiado en el servidor. Por favor, inténtelo de nuevo.'
          });
        }
        return throwError(() => err);
      })
    );
  }
}
